// document.addEventListener('DOMContentLoaded', ()=>{
//   setTimeout(()=>{
//     const tl = gsap.timeline();
//       tl.from('#shopify-section-sections--24627097665812__header .m-logo__image-default img', {
//         y:-10,
//         opacity:0,
//         duration: 0.5
//       })
//     tl.from('#shopify-section-sections--24627097665812__header .m-menu__item', {
//       y:-10,
//       opacity:0,
//       stagger: 0.3
//     })
//     tl.to('#m-slider-template--24627104252180__slider_ncRGN8 .m-richtext__description h1', {
//       scale: 2,
//       scrollTrigger: {
//         trigger: '#m-slider-template--24627104252180__slider_ncRGN8 .m-slide__wrapper',
//         scroller: 'body',
//         scrub: 2,
//         pin:true
//       }
//     })
//   }, 1000)
// })

// current code

// const cart_checkout = document.querySelector('.an--cart__checkout-button');
// const cart_footer = document.querySelector('.shopify-section-group-footer-group')
// document.addEventListener('DOMContentLoaded', ()=>{
//     if(window.innerWidth > 600){
//         cart__checkout.classList.remove('an--sticky_bottom_checkout--js');
//     } else {
//     }
// })

// document.addEventListener('scroll', ()=>{
//     if(Math.trunc(cart_footer.getBoundingClientRect().top) < 400){
//         cart_checkout.classList.remove('an--sticky_bottom_checkout--js');
//     } else {
//         cart_checkout.classList.add('an--sticky_bottom_checkout--js');
//     }
// })





const cart_checkout = document.querySelector('.an--cart__checkout-button');
const cart_footer = document.querySelector('.shopify-section-group-footer-group');

document.addEventListener('DOMContentLoaded', ()=>{
    if (!cart_checkout) return;

    if(window.innerWidth > 600){
        cart_checkout.classList.remove('an--sticky_bottom_checkout--js');
    } else {
    }
});

document.addEventListener('scroll', ()=>{
    if (!cart_checkout || !cart_footer) return;

    if(Math.trunc(cart_footer.getBoundingClientRect().top) < 400){
        cart_checkout.classList.remove('an--sticky_bottom_checkout--js');
    } else {
        cart_checkout.classList.add('an--sticky_bottom_checkout--js');
    }
});